import {ProviderData} from '@shared/interfaces';

export const isOwner = (userRole: string): boolean => {
  return userRole && ['owner', 'superuser'].includes(userRole);
};

export const isReadOnly = (userRole: string): boolean => {
  return userRole && ['read-only', 'readonly'].includes(userRole);
};

export const hasProviderId = (providerData: ProviderData[], id: string): boolean => {
  if (!providerData) {
    return false;
  }
  for (const provider of providerData) {
    if (provider.providerId === id) {
      return true;
    }
  }
  return false;
};
